



























import { Vue, Component } from 'vue-property-decorator';
import { ResetPasswordEntity } from '../models/reset-password';
import authService from '@/services/authentication.service';

@Component({})
export default class ResetPassword extends Vue {

  public resetPassword: ResetPasswordEntity = new ResetPasswordEntity();

  public handleSubmit() {
     authService
      .resetPassword(this.resetPassword)
      .then((response: any) => {
          this.$router.push('/');
      })
      .catch((error: Error) => {
        // tslint:disable-next-line
        console.error(error);
      });
  }
}
